import { getAnonymousID as rlGetAnon } from "redline-client-sdk"

export default function getAnonymousId() {
  return rlGetAnon()
}
